import React, { useMemo, useState, useEffect } from "react";
import our_vision from "../static/images/aboutUs/our_vision.jpg";
import who_are_we from "../static/images/aboutUs/who_are_we.jpg";
import mission_1 from "../static/images/aboutUs/Mission_1.webp";
import mission_2 from "../static/images/aboutUs/Mission_2.webp";
import mission_3 from "../static/images/aboutUs/Mission_3.webp";
import isha from "../static/images/aboutUs/Isha.jpeg";
import tripta from "../static/images/tripta.jpg";
import "../sass/main.scss";
import LazyImage from "../components/LazyImage.js";
import useWindowDimensions from "../hooks/useWindowDimensions.js";
import { Banner } from "../components/banner.js";
import AnimatedContent from "../animatedComponents/AnimatedContent.js";

const missionData = [

  {
    icon: mission_1,
    heading: "Travel",
    description:
      "Redefine the way you see the world; through customized journeys rooted in authenticity.",
  },
  {
    icon: mission_2,
    heading: "Connect",
    description:
      "Foster meaningful connections between women travelers, culture, communities and the destination; we want travel to uplift you.",
  },
  {
    icon: mission_3,
    heading: "Discover",
    description:
      "Experiences that resonate with your values, interests and aspirations, crafted to inspire, challenge and empower.",
  }
];

export const AboutUs = () => {
  const { width } = useWindowDimensions();
  const [joyBannerFontSize, setJoyNowBannerFontSize] = useState("1.8rem");
  useEffect(() => {
    if (width > 900 && width <= 1200) {
      setJoyNowBannerFontSize("1.8rem");
      return;
    } else if (width > 600 && width <= 900) {
      setJoyNowBannerFontSize("1.6rem");

      return;
    } else if (width <= 600) {
      setJoyNowBannerFontSize("1.3rem");

      return;
    }

    setJoyNowBannerFontSize("1.8rem");

    return;
  }, [width]);



  const renderMissionData = useMemo(() => {
    return missionData.map((element) => {
      return (
        <div className="mission-column">
          <LazyImage
            notFullHeight={true}
            component={
              <img
                src={element.icon}
                alt={element.heading}
                className="mission-img"
              />
            }
          />
          <h2 className="mission-heading">{element.heading}</h2>
          <p className="mission-description">{element.description}</p>
        </div>
      );
    });
  }, []);

  const renderFounderBanner = useMemo(() => {
    if (width >= 600) {
      return (
        <div className="founders-container">
          <div className="founders-container-banner">
            <div className="founders-container-banner-founder">
              <div className="founders-image-container">
                <LazyImage imgOnly={true} alt="Isha Goyal" src={isha} className="founders-image"
                  styleish={{ objectPosition: "center" }}
                />
              </div>
              <h2>Isha Goyal</h2>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                <p>
                  Isha Goyal, Executive Director & CEO of STIC Travel Group, and co-founder of WanderLuxe, is a visionary
                  leader in the travel industry. With over 20 years of experience, Isha has honed her expertise in crafting
                  luxurious and secure travel experiences.
                </p>
                <p>
                  Based in Singapore and deeply connected to her roots in India, she brings a unique global perspective to
                  her ventures. WanderLuxe was born out of Isha's passion for exploration and her commitment to creating
                  enriching travel experiences for women.
                </p>
              </div>
            </div>


            <div className="founders-container-banner-founder" style={{ marginRight: 0 }}>
              <div className="founders-image-container">
                <LazyImage imgOnly={true} alt="Tripta Singh" className="founders-image" src={tripta} styleish={{ objectPosition: "center" }} />
              </div>
              <h2>Tripta Singh</h2>
              <div style={{ display: "flex", flexDirection: "column", justifyContent: "space-between", height: "100%" }}>
                <p>
                  Tripta Singh is an avid traveller with 30 years of experience in the corporate world, spanning media,
                  broadcasting, digital, and children's toys. Having explored over 50 countries with family, friends, and her
                  cherished women's travel tribe, she brings with her a wealth of travel knowledge and passion. For the past
                  20 years, Tripta has called Singapore home.
                </p>
                <p>
                  Her latest venture, WanderLuxe, is a labour of love aimed at unveiling the hidden gems of India and beyond
                  to Singaporeans and expats, oﬀering them experiences like never before.
                </p>
              </div>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div className="founders-container">
        <div className="founders-container-banner">
          <div className="founders-container-banner-founder">
            <LazyImage
              imgOnly
              src={isha}
              className="founders-image"
              styleish={{
                width: "100%",
                objectFit: "contain",
                height: "100%",
                margin: "0 0 2rem 0",
              }}
              alt={"Isha Goyal"}
            />
            <h2 style={{ marginTop: "0" }}>Isha Goyal</h2>
            <p>
              Isha Goyal, Executive Director & CEO of STIC Travel Group, and co-founder of WanderLuxe, is a visionary
              leader in the travel industry. With over 20 years of experience, Isha has honed her expertise in crafting
              luxurious and secure travel experiences.
            </p>
            <p>
              Based in Singapore and deeply connected to her roots in India, she brings a unique global perspective to
              her ventures. WanderLuxe was born out of Isha's passion for exploration and her commitment to creating
              enriching travel experiences for women.
            </p>
          </div>

          <div className="founders-container-banner-founder">
            <LazyImage
              imgOnly
              src={tripta}
              className="founders-image"
              styleish={{
                width: "100%",
                marginTop: "5rem",
                objectFit: "cover",
                height: "100%"
              }}
              alt={"Tripta Singh"}
            />

            <h2>Tripta Singh</h2>
            <p>
              Tripta Singh is an avid traveller with 30 years of experience in the corporate world, spanning media,
              broadcasting, digital, and children's toys. Having explored over 50 countries with family, friends, and her
              cherished women's travel tribe, she brings with her a wealth of travel knowledge and passion. For the past
              20 years, Tripta has called Singapore home.
            </p>
            <p>
              Her latest venture, WanderLuxe, is a labour of love aimed at unveiling the hidden gems of India and beyond
              to Singaporeans and expats, oﬀering them experiences like never before.
            </p>
          </div>
        </div>
      </div>
    );
  }, [width]);

  return (
    <div>
      <AnimatedContent>
        <h1 className="cu-heading">About Us</h1>
        <LazyImage component={<div className="header__about-us" />} />
      </AnimatedContent>


      <div className="about-us-container">
        <AnimatedContent className="about-us-leftSide">
          <h1 className="about-us-leftSide-heading">Our Vision</h1>
          <p>
            At WanderLuxe, we envision a world where travel transcends boundaries, connections deepen
            understanding, and discoveries inspire personal growth. We strive to be the catalyst for transformative
            journeys that empower women to explore the world with confidence, curiosity, and compassion.
          </p>
          <LazyImage imgOnly className="about-us-leftSide-img" src={our_vision} alt="" />
        </AnimatedContent>
        <AnimatedContent className="about-us-rightSide">
          <div>
            <h1 className="about-us-rightSide-heading">
              Who Are We?
            </h1>
            <p>
              We curate experiences designed specially for women—crafted by experts, led by passion.
              With years of expertise and a deep-rooted love for the destinations, our founders are on a
              mission to redefine the way you see the world.
            </p>
          </div>
          <LazyImage imgOnly className="about-us-rightSide-img" src={who_are_we} alt="" />
        </AnimatedContent>
      </div>

      <div className="about-us-img-container">

      </div>

      <AnimatedContent className="mission-content-container">
        <h1
          className="mission-content-heading"
        >
          Our Mission
        </h1>
        <div className="about-us-mission-row">
          {renderMissionData}

        </div>
      </AnimatedContent>

      <AnimatedContent>
        <h1 className="founders-heading" style={{ textAlign: width < 600 ? "left" : "center" }}>
          Meet Our Founders
        </h1>
        <Banner
          headingStyle={{
            lineHeight: width < 600 && "2rem",
            marginBottom: 0,
            padding: width < 600 && "1rem"
          }}
          heading={"Recognizing the need for safe, authentic journeys, Isha and Tripta partnered to oﬀer aﬀordable luxury, tailored adventures for women that reflect their shared love for travel to India and beyond."}
          fontSize={joyBannerFontSize}
          renderIcons={true}
          backgroundColor={"#97789B"}
          style={{ alignSelf: "center", padding: "0.5rem", height: width < 600 && "30vh", marginTop: "1rem" }}
          width={width > 600 ? "75%" : "100%"}
        />
        {renderFounderBanner}
      </AnimatedContent>
    </div>
  );
};
